/**
 * Returns true if the selected period's end date is today or in the future.
 * Potential sales only make sense for current/future periods.
 */
export function isPotentialVisible(endDateStr: string): boolean {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const periodEnd = new Date(endDateStr);
  periodEnd.setHours(0, 0, 0, 0);
  return periodEnd >= today;
}

/** Computes the end date string from period params (used by Négociateur & Direction tables). */
export function getPeriodEndDate(
  period: 'year' | 'quarter' | 'month',
  selectedPeriod: string,
  fiscalYear: number,
): string {
  if (period === 'year') {
    return `${fiscalYear + 1}-03-31`;
  }
  if (period === 'quarter') {
    const quarterEndMonth: Record<string, { end: string; year: number }> = {
      '1': { end: '06', year: fiscalYear },
      '2': { end: '09', year: fiscalYear },
      '3': { end: '12', year: fiscalYear },
      '4': { end: '03', year: fiscalYear + 1 },
    };
    const q = quarterEndMonth[selectedPeriod] ?? quarterEndMonth['1'];
    const lastDay = new Date(q.year, parseInt(q.end), 0).getDate();
    return `${q.year}-${q.end}-${String(lastDay).padStart(2, '0')}`;
  }
  // month
  const month = selectedPeriod.padStart(2, '0');
  const year = parseInt(selectedPeriod) <= 3 ? fiscalYear + 1 : fiscalYear;
  const lastDay = new Date(year, parseInt(month), 0).getDate();
  return `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
}
